import { MouseEvent } from 'react'
import { Component, createRef } from 'react'
import './Menu.scss'
import { Part, PartAction } from '../Types'
import Confirm from './Confirm'
import { preventContextMenu } from '../Utils'
import { isDebug } from '../App.config'

interface Props {
    replaceItem: Function
    viewSpecs: Function
}

interface State {
    visible: boolean
    part: Part
    showConfirmReplace: boolean
}

export default class ContextMenu extends Component<Props, State> {
    private menu = createRef<HTMLDivElement>()

    state: State = {
        visible: false,
        part: {} as Part,
        showConfirmReplace: false
    }

    hideMenu = () => {
        this.removeEventListeners()
        this.setState({ visible: false, })
    }

    removeEventListeners = () => {
        document.removeEventListener('click', this.handleClick)
        document.removeEventListener('scroll', this.handleScroll)
    }

    handleContextMenu = (xPos: number, yPos: number, part: Part) => {
        this.setState({
            visible: true,
            part
        })
        this.showMenu(xPos, yPos)
    }

    handleClick = (event: any) => {
        isDebug && console.log('context menu click handler')
        const clickTarget = event.target as HTMLDivElement
        const wasOutside = this.menu.current && !this.menu.current.contains(clickTarget)

        if (wasOutside || clickTarget.dataset.contextitem) this.hideMenu()

        if (clickTarget.dataset.contextitem === PartAction.Replace) {
            this.setState({ showConfirmReplace: true })
            return
        }

        if (clickTarget.dataset.contextitem === PartAction.ViewSpecs) {
            this.props.viewSpecs(this.state.part)
        }
    }

    handleScroll = () => this.state.visible && this.setState({ visible: false, })

    showMenu = (xPos: number, yPos: number) => {
        document.addEventListener('click', this.handleClick)
        document.addEventListener('scroll', this.handleScroll)
        const contextMenu = this.menu.current

        if (!contextMenu) return
        const clickX = xPos, clickY = yPos, screenW = window.innerWidth, screenH = window.innerHeight

        const menuW = contextMenu.offsetWidth
        const menuH = contextMenu.offsetHeight
        const right = (screenW - clickX) > menuW
        const left = !right
        const top = (screenH - clickY) > menuH
        const bottom = !top
        if (right)
            contextMenu.style.left = `${clickX + 5}px`
        if (left)
            contextMenu.style.left = `${clickX - menuW - 5}px`
        if (top)
            contextMenu.style.top = `${clickY + 5}px`
        if (bottom)
            contextMenu.style.top = `${clickY - menuH - 5}px`

    }

    hideConfirmReplace = () => this.setState({ showConfirmReplace: false })

    doReplace = (part: Part) => {
        this.props.replaceItem(part)
        this.hideConfirmReplace()
    }

    getMenuItems = (part: Part) => {
        const result: PartAction[] = Object.values(part.actions)

        return result.map((action: PartAction, i: number) => (
            <div key={i} className="menu--option" data-contextitem={action}>
                {action}
            </div>
        ))
    }

    render() {
        const { visible, part, showConfirmReplace } = this.state
        if (!part.actions) return <></>

        const menuItems = this.getMenuItems(part)
        const confirmTitle = `Replace ${part.partID}?`
        const confirmBody =
            `Are you sure you want to replace the ${part.partID} ${part.partType}?`
        const confirmBtnTxt = 'Replace'

        return (
            <>
                <Confirm
                    key={'confirmreplace'}
                    show={showConfirmReplace}
                    title={confirmTitle}
                    body={confirmBody}
                    onConfirm={() => {
                        this.doReplace(part)
                    }}
                    onHide={() => { this.hideConfirmReplace() }}
                    confirmText={confirmBtnTxt}
                    cancelText='Cancel'
                />
                {
                    visible && (
                        <div
                            onContextMenu={(e: MouseEvent) => preventContextMenu(e)}
                            ref={this.menu}
                            className="menu"
                        >
                            <div className="menu--option disabled">{part.partType}: {part.partID} </div>
                            <div className="menu--separator" />
                            {menuItems}
                        </div>
                    )
                }
            </>
        )
    }
}
